module.exports = __webpack_public_path__ + "img/2.b5fcd5d2.png";